<template>
  <div id="specialFilePage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="پرونده تخصصی"></ActionBar>
    <div class="container mx-auto  mt-2">
      <div v-if="!hasData" class="row mx-2 mt-10 knowledge-base-body">
        <div class="col-12">
          <v-alert
              border="bottom"
              class="mt-4 text-center"
              color="primary"
              dark>
            پرونده ای وجود ندارد
          </v-alert>
        </div>
      </div>
      <div v-else class="row">
        <div v-for="item in items" :key="item.SpecializedFileStudentProfileID"
             class="col-12 col-sm-6 col-md-6 col-lg-4 py-1">
          <div v-if="item.SpecializedFileName !== null"
               class="row no-gutters p-2 pl-0 card-right-line bg-white rounded-l-lg cursor-pointer"
               @click="getDetail(item.FileUrl,item.SpecializedFileName)">
            <div class="col-2">
              <img :src="getImgUrl('file-report.png')" alt="پرونده" class="vertically-center img-fluid">
            </div>
            <div class="col-9">
              <div class="mt-1"> {{ item.SpecializedFileName }}</div>
            </div>
            <div class="col-1">
              <i class="fas fa-chevron-left vertically-center primary-text pr-1"
                 @click="getDetail(item.FileUrl,item.SpecializedFileName)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "SpecialFile",
  metaInfo: {
    title: 'مسیربرتر-پرونده تخصصی'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    showLoaderDialog: false,
    items: [],
    hasData:true

  }),
  mounted() {
    _this = this;
    this.showLoaderDialog = true
    this.getData()
  },
  methods: {
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SpecializedFileManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false
            let json =  JSON.parse(result)
            if(json.length >0) {
              _this.items =json
              this.hasData= true
            }else {
              this.hasData=false
            }
          })
          .catch(error => console.log('error', error));
    },
    getDetail(fileUrl, name) {
      this.$router.push({path: 'SpecialFileDetail', query: {Name: name, FileUrl: fileUrl}})
      /* this.showLoaderDialog = true
       let myHeaders = new Headers();
       myHeaders.append("Authorization", _this.$getUserData().token);
       myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

       let requestOptions = {
         method: 'GET',
         headers: myHeaders,
         redirect: 'follow'
       };

       fetch(this.$baseUrl + "SpecializedFileManagement/SpecializedFileDetails?SpecializedFileID=" + id, requestOptions)
           .then(response => response.text())
           .then(result => {
             _this.showLoaderDialog = false
             console.log(result)
           })
           .catch(error => console.log('error', error));*/
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    // goToSpecialFileDetail(item) {
    //   this.$global.specialFileItem = item;
    //
    // }
  }
}
</script>

